module.exports = __webpack_public_path__ + "static/media/icon-overflow.fe8de5d7.svg";